module.exports = __webpack_public_path__ + "assets/fonts/alert-triangle.7dd561c1.svg";